import { BaseGameState } from '../socketEvents/socketEvents';

export enum UNITY_GAME_STATE {
  PLAYING = 'PLAYING',
}

export interface UnityGameState extends BaseGameState {
  gameState: UNITY_GAME_STATE;
}
